import dayjs from 'dayjs';
import { date,object, string } from 'yup';

import { createValidator } from '@src/validation';
import { textValidator } from '@src/validation/textValidator';

const validateSchema = object().shape({
  reportCode: string().trim().required(),
  version: textValidator({ fieldName: 'version' })
    .typeError('Поле должно быть числом')
    .length(3, 'Поле должно содержать 3 символа'),
  name: textValidator({ fieldName: 'name' }),
  beginDate: date().nullable().required(),
  finishDate: date()
    .nullable()
    .test('isBefore', 'Дата окончания должна быть позже даты начала', (value, { parent: { beginDate } }) => {
      if (!beginDate) return true;

      return !dayjs(new Date(`${value}`)).isBefore(dayjs(new Date(beginDate)));
    }),
});

export const validate = createValidator(validateSchema);
